import { Form } from "antd";
import React, {
  forwardRef,
} from "react";
import GenericMappingForm from "../GenericMappingForm";

const UpwindMappingForm = forwardRef(
  function UpwindMappingForm({ disableProjectFields = false, ...props }, ref) {
    const [form] = Form.useForm();
    return (
      <GenericMappingForm
        ref={ref}
        form={form}
        {...props}
      />
    );
  },
);

export default UpwindMappingForm;